import { DaoInfoType } from "~/modules/Router/Auth/types";

type Props = {
  fontClassName?: string;
  dao: Pick<DaoInfoType, "description" | "displayName">;
};
export const CommunityDescription = ({ fontClassName, dao }: Props) => {
  return (
    <p
      className={`${fontClassName} whitespace-pre-wrap break-words text-center text-ciety-wh line-clamp-3`}
    >
      {dao.description && dao.description.length > 0 ? (
        dao.description
      ) : (
        <>
          Welcome to the {dao.displayName}
          <br />
          Feel free to join us
        </>
      )}
    </p>
  );
};
